import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Icon from "../../../components/Icon";
import { message } from "../../../actions";
import { deleteBlocks, getBlocks } from "../actions/Blocks";
import { deleteQuestions } from "../actions/Questions";
import { deleteAnswers } from "../actions/Answers";
import { patchQuestionnaires } from "../actions/Questionnaires";
import QuestionnaireTree from "./QuestionnaireTree";
import Block from "../containers/Block";
import Question from "../containers/Question";
import Answer from "../containers/Answer";
import Modal from "../../../components/Modal";

const mapStateToProps = ( state ) =>
{
	return {
		questionnaires: state.questionnaires,
		blocksByQuestionnaireId: state.blocksByQuestionnaireId
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		getBlocks: ( questionnaireId ) =>
		{
			dispatch( getBlocks( questionnaireId ) );
		},
		deleteBlocks: ( id, questionnaireId ) =>
		{
			dispatch( deleteBlocks( id, questionnaireId ) );
		},
		deleteQuestions: ( id, questionnaire_id, block_id ) =>
		{
			dispatch( deleteQuestions( id, questionnaire_id, block_id ) );
		},
		deleteAnswers: ( id, a_questionnaire_id, a_block_id, a_question_id ) =>
		{
			dispatch( deleteAnswers( id, a_questionnaire_id, a_block_id, a_question_id ) );
		},
		patchQuestionnaires: ( formData ) =>
		{
			dispatch( patchQuestionnaires( formData ) );
		},
		message: ( a_message, a_type, a_timeout ) =>
		{
			dispatch( message( a_message, a_type, a_timeout ) );
		}
	};
};

class QuestionnaireEditor extends React.Component
{
	static MAX_SORT_ID = 2147483647;
	
	constructor( props )
	{
		super( props );
		
		this.state = {
			deleteNode: false,
			newNode: false,
			createType: null,
			editNode: null,
			nodeType: null,
			lastSelectedNode: null,
			show: props.show !== null ? props.show : "regularTree"
		};
		
		this.onSelect = this.onSelect.bind( this );
		this.onCreate = this.onCreate.bind( this );
		this.onDelete = this.onDelete.bind( this );
		
	} // function constructor(...)
	
	componentDidMount()
	{
		this.props.getBlocks( this.props.questionnaireId );
		
	} // function componentDidMount()
	
	/**
	 * Wird jedes Mal aufgerufen, wenn sich etwas an der Komponente geändert hat.
	 *
	 * @param prevProps Die vorherigen Eigenschaften
	 * @param prevState Der vorherige State
	 * @param snapshot
	 */
	componentDidUpdate( prevProps, prevState, snapshot )
	{
		const { blocksByQuestionnaireId, questionnaireId } = { ...this.props };
		
		const node = this.state.editNode;
		if ( node && node.id )
		{
			// Wenn Sortiert wurde, dann das aktuell ausgewählte Element aktualisieren
			const blocks = blocksByQuestionnaireId[questionnaireId];
			switch ( node.type )
			{
				case "blocks":
					if ( node.sortId !== blocks[node.id].sort_id )
					{
						this.setState( {
							editNode: Object.assign(
								{},
								this.state.editNode,
								{
									sortId: blocks[node.id].sort_id
								}
							)
						} );
					}
					break;
				case "questions":
					if ( blocks[node.block_id]["questions"][node.id] &&
						node.sortId !== blocks[node.block_id]["questions"][node.id].sort_id )
					{
						this.setState( {
							editNode: Object.assign(
								{},
								this.state.editNode,
								{
									sortId: blocks[node.block_id]["questions"][node.id].sort_id
								}
							)
						} );
					}
					break;
				case "answers":
					if ( blocks[node.block_id]["questions"][node.question_id]["answers"][node.id] &&
						node.sortId !== blocks[node.block_id]["questions"][node.question_id]["answers"][node.id].sort_id )
					{
						this.setState( {
							editNode: Object.assign(
								{},
								this.state.editNode,
								{
									sortId: blocks[node.block_id]["questions"][node.question_id]["answers"][node.id].sort_id
								}
							)
						} );
					}
					break;
				default:
					this.props.message( "Es ist ein Fehler aufgetreten.", "error" );
					break;
			}
		}
		
	} // function componentDidUpdate(...)
	
	/**
	 * Event: Wenn eine Auswahl (Block, Frage, Antwort) im Baum getroffen wird
	 *
	 * @param {string} selectedKey Informationen zu der angeklickten Auswahl
	 * @param {string} treeNode Informationen zu der angeklickten Auswahl
	 */
	onSelect( selectedKey, treeNode )
	{
		if ( treeNode && (
			( treeNode.hasOwnProperty( "created" ) && treeNode.created )
			|| ( treeNode.hasOwnProperty( "selected" ) && treeNode.selected )
			|| ( treeNode.hasOwnProperty( "dropToGap" ) && treeNode.dropToGap )
		) )
		{
			const { blocksByQuestionnaireId, questionnaireId } = { ...this.props };
			
			// Prüfe ob weitere Fragen oder Antworten angelegt werden dürfen
			let createable = true;
			switch ( treeNode.node.props.type )
			{
				case "questions":
					createable = !treeNode.node.props.binary || Object.keys( treeNode.node.props.children ).filter( a_key => treeNode.node.props.children[a_key].id ).length < 2;
					break;
				case "answers":
					const questionAnswers = blocksByQuestionnaireId[questionnaireId][treeNode.node.props.block_id]["questions"][treeNode.node.props.question_id]["answers"];
					createable = !treeNode.node.props.binary || Object.keys( questionAnswers ).length < 2;
					break;
				default:
					break;
			}
			
			this.setState( {
				deleteNode: true,
				newNode: false,
				createType: null,
				editNode: treeNode.node.props,
				nodeType: treeNode.node.props.type,
				createable: createable,
				lastSelectedNode: treeNode.node.props
			} );
		}
		else
		{
			this.setState( {
				deleteNode: false,
				newNode: false,
				createType: null,
				editNode: null,
				nodeType: null,
				createable: false,
				lastSelectedNode: null
			} );
		}
		
	} // function onSelect(...)
	
	/**
	 * Event: Wenn ein markiertes Element (Block, Frage, Antwort) im Baum gelöscht werden soll
	 */
	onDelete()
	{
		const { questionnaires, questionnaireId } = { ...this.props };
		const node = this.state.editNode;
		
		switch ( node.type )
		{
			case "blocks":
				this.props.deleteBlocks( node.id, questionnaireId );
				break;
			case "questions":
				this.props.deleteQuestions( node.id, questionnaireId, node.block_id );
				break;
			case "answers":
				this.props.deleteAnswers( node.id, questionnaireId, node.block_id, node.question_id );
				break;
			default:
				break;
		}
		
		// Fragebogen wieder deaktivieren
		if ( questionnaires[questionnaireId].active === "1" )
		{
			this.props.patchQuestionnaires( { ...questionnaires[questionnaireId], active: "0" } );
		}
		
		this.setState( {
			deleteNode: false,
			newNode: false,
			createType: null,
			editNode: null,
			nodeType: null,
			createable: false,
			lastSelectedNode: null
		} );
		
	} // function onDelete()
	
	/**
	 * Formular anzeigen: Wenn ein Element (Block, Frage, Antwort) im Baum angelegt werden soll.
	 *
	 * @param {string} type Informationen zu der angeklickten Auswahl
	 */
	onCreate( type )
	{
		this.setState( { editNode: null, createType: type, newNode: true } );
		
	} // function onCreate(...)
	
	/**
	 * Event: Wenn ein Sichtwechsel erfolgen soll.
	 */
	onSwitchShow()
	{
		const shows = [ "shortTree", "regularTree", "longTree" ];
		const currentIndex = shows.indexOf( this.state.show );
		this.setState( { show: currentIndex === 0 ? shows[shows.length - 1] : shows[currentIndex + 1] } );
		
	} // function onSwitchShow()
	
	/**
	 * Prüfe ob Änderungen am Element vorliegen.
	 *
	 * @param {Object} a_node       Ausgangselement
	 * @param {Object} a_formData   Geändertes Element
	 */
	static compareNodes( a_node, a_formData )
	{
		let isChanged = false;
		Object.keys( a_node ).sort().forEach( a_key =>
			{
				if ( a_formData.hasOwnProperty( a_key ) && a_node[a_key] !== a_formData[a_key] )
				{
					isChanged = true;
				}
			}
		);
		
		return isChanged;
		
	} // function compareNodes(...)
	
	render()
	{
		const { questionnaireId } = { ...this.props };
		
		// Größen für den Sichtwechsel
		let treeClassName = "col s12 unset-padding-left treeMenu";
		let editorClassName = "col s12 unset-padding-right";
		switch ( this.state.show )
		{
			case "shortTree":
				treeClassName += " m4 l2 xl1";
				editorClassName += " m8 l10 xl11";
				break;
			case "longTree":
				treeClassName += " m6 l8 xl10";
				editorClassName += " m6 l4 xl2";
				break;
			case "regularTree":
			default:
				treeClassName += " m6 l4 xl2";
				editorClassName += " m6 l8 xl10";
				break;
		}
		
		// Form anhand des ausgewählten Elementes laden
		let form = null;
		let deleteText = "";
		const lastSelectedNode = this.state.lastSelectedNode ? this.state.lastSelectedNode : null;
		const props = {};
		if ( this.state.editNode )
		{
			props["node"] = this.state.editNode;
		}
		
		switch ( this.state.editNode ? this.state.editNode.type : this.state.createType )
		{
			case "blocks":
				form = <Block {...props} className={editorClassName} isNew={this.state.newNode} lastSelectedNode={lastSelectedNode} questionnaireId={questionnaireId}/>;
				deleteText = "Soll der Block und alle dazugehörigen Fragen und Antworten gelöscht werden?";
				break;
			case "questions":
				form = <Question {...props} className={editorClassName} isNew={this.state.newNode} lastSelectedNode={lastSelectedNode} questionnaireId={questionnaireId}/>;
				deleteText = "Soll die Frage und alle dazugehörigen Antworten gelöscht werden?";
				break;
			case "answers":
				form = <Answer {...props} className={editorClassName} isNew={this.state.newNode} lastSelectedNode={lastSelectedNode} questionnaireId={questionnaireId}/>;
				deleteText = "Soll die Antwort gelöscht werden?";
				break;
			default:
				form = null;
				break;
		}
		
		return <section className={"white"}>
			<div className={"col s12 light-grey padding-top"}>
				<button title={"Block hinzufügen"} onClick={() => this.onCreate( "blocks" )}
				        className={"btn btn-middle white primary-color-text hover-primary-color hover-white-text icon-shadow"}>
					<Icon verticalAlign={"middle"} size={18} iconName={"blocks"}/>
				</button>
				<button title={"Frage hinzufügen"} onClick={() => this.onCreate( "questions" )}
				        className={"btn btn-middle white primary-color-text hover-primary-color hover-white-text icon-shadow"}
				        disabled={this.state.nodeType === null}>
					<Icon verticalAlign={"middle"} size={18} iconName={"questions"}/>
				</button>
				<button title={"Antwort hinzufügen"} onClick={() => this.onCreate( "answers" )}
				        className={"btn btn-middle white primary-color-text hover-primary-color hover-white-text icon-shadow"}
				        disabled={this.state.nodeType === null || this.state.nodeType === "blocks" || !this.state.createable}>
					<Icon verticalAlign={"middle"} size={18} iconName={"answers"}/>
				</button>
				{
					// Wenn Löschen erlaubt ist und eine Id besitzt. Templates haben keine Id.
					this.state.deleteNode && this.state.editNode && this.state.editNode.hasOwnProperty( "id" ) &&
					<Modal
						className={"confirm"}
						key={"block_delete_modal"}
						trigger={
							<button title={"Ausgewähltes Element löschen"}
							        className={"btn btn-middle white red-text hover-primary-color hover-white-text icon-shadow"}>
								<Icon verticalAlign={"middle"} size={18} iconName={"delete"}/>
							</button>
						}
						footer={
							<React.Fragment>
								<button onClick={this.onDelete.bind( this )} data-modal={"confirm"}><Icon size={14} iconName={"delete"}/><span>Ja</span></button>
								<button className={"secondary-color"} data-modal={"close"}><Icon iconName={"discard"}/><span>Nein</span></button>
							</React.Fragment>
						}
					>
						<p className={"tCenter"}>{deleteText}</p>
					</Modal>
				}
				<div className={"right"}>
					<button title={"Menüsicht wechseln"} onClick={this.onSwitchShow.bind( this )}
					        className={"btn btn-middle white primary-color-text hover-primary-color hover-white-text icon-shadow"}>
						<Icon verticalAlign={"middle"} size={18} iconName={"showSwitch"}/>
					</button>
				</div>
			</div>
			<QuestionnaireTree draggable
			                   className={treeClassName}
			                   questionnaireId={questionnaireId}
			                   collapseOrExpandAll={"expand"}
			                   show={this.state.show}
			                   onSelect={this.onSelect}
			                   treePrefix={"menuTree"}
			/>
			{form}
		</section>;
		
	} // function render()
	
} // class

QuestionnaireEditor.propTypes = {
	questionnaireId: PropTypes.oneOfType( [ PropTypes.number, PropTypes.string ] ).isRequired,
	show: PropTypes.oneOf( [ "regularTree", "longTree", "shortTree", null ] )
};

QuestionnaireEditor = connect(
	mapStateToProps,
	mapDispatchToProps
)( QuestionnaireEditor );

export default QuestionnaireEditor;